import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@/app/hook';
import { PSInput } from '@/components/ui/input';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';
import { BotTypeEnum } from '@/utils/BotTypeEnum';

import { selectCurrentDataState } from '../create.slice';

const ChatbotName = ({ order }: { order?: string }) => {
  const { t } = useTranslation();
  const { register, formState, setValue } = useFormContext();
  const currentType = useFormContext().getValues('bot_code');
  const currentData = useAppSelector(selectCurrentDataState);

  useEffect(() => {
    if (!currentData || Object.keys(currentData).length === 0) return;
    if (currentData?.title) {
      setValue('title', currentData.title);
    } else setValue('title', '');
  }, [currentData]);

  return (
    <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-5 tw-flex tw-mb-5">
      <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-flex">
        <div className="tw-self-stretch tw-text-gray-900 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
          {order} {currentType === BotTypeEnum.HUMAN_CLONE ? t('Wizard/step1/key10') : t('Wizard/step1/key7')}
        </div>
        <div className="tw-self-stretch tw-text-gray-900 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
          {currentType === BotTypeEnum.HUMAN_CLONE ? t('Wizard/step1/key11') : t('Wizard/step1/key8')}
        </div>
      </div>
      <div className="md:tw-max-w-[357px] tw-w-full tw-justify-start tw-items-start tw-gap-2 tw-flex tw-flex-col">
        <PSInput
          maxLength={31}
          max={31}
          type="text"
          className={`tw-w-full tw-px-4 tw-py-2.5 tw-bg-white tw-rounded-md tw-shadow tw-border tw-border-gray-300 placeholder:tw-text-gray-400 tw-text-sm tw-font-normal tw-tw-font-['Lexend'] tw-leading-tight`}
          {...register('title')}
          //onChange={handleChooseNameForBot}
          inputMode="text"
          onKeyDown={e => {
            if (e.key === 'Enter') e.preventDefault();
          }}
        />
        {!!formState?.errors?.title && <p className="tw-text-red-600 tw-text-base tw-font-semibold">{formState.errors.title.message as string}</p>}
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(ChatbotName);
